import React from 'react'
import InputText from 'components/Inputs/InputText'

const Phone = React.forwardRef((props, ref) => (
  <InputText ref={ref} name="phone" label="Phone" {...props} />
))

export default Phone
